import { render, staticRenderFns } from "./cancelRegistrationPage.vue?vue&type=template&id=3146cccd&scoped=true&"
import script from "./cancelRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./cancelRegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./cancelRegistrationPage.vue?vue&type=style&index=0&id=3146cccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146cccd",
  null
  
)

export default component.exports